import React from 'react';

import { Box, Card, Text } from '@brand/components';

import { Review } from '@domain/entities';

import { StarRating } from '@hoa/molecules';

import { useTranslation } from '@hoa/hooks';

interface Props {
  review: Review;
}

export const CategoryRatingReview = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Card bg="gray.50" h="280px">
      <Text size="lg" color="heading" fontWeight="bold" mb={4}>
        {props.review.companyname}
      </Text>
      <Text size="sm" mb={2} maxHeight="140px" overflow="auto">
        {props.review.description}
      </Text>
      <Box mb={2}>
        <StarRating
          score={props.review.rating}
          size="sm"
          justifyContent="flex-start"
        />
      </Box>
      <Text textTransform="uppercase" size="xs" color="gray.400">
        {t(`category:jobs.rating.by`)} {props.review.by}
      </Text>
    </Card>
  );
};
